import { Box, Button, Typography, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Icon } from "components/icons";
import { SLOW_WALK_NOTICE_MS } from "components/audience-map/routeWalk";

import { style } from "./style";

const useStyles = makeStyles(() => style);

/**
 * @param {object} props
 * @param {string|number|null} [props.loadingPercentage]
 * @param {boolean} [props.isCalculatingMultipleSelection]
 * @param {(() => void)|null} [props.onCancel] omit it where there is nothing
 *   cancellable to offer (AudienceMapEDDMV2); the Cancel control is then hidden.
 */
export const LoadingScreen = ({ loadingPercentage, isCalculatingMultipleSelection, onCancel = null }) => {
  const classes = useStyles();
  // A dense metro at a 10-mile radius genuinely takes tens of seconds. Rather
  // than leaving the user staring at an unchanging spinner wondering whether it
  // is stuck, say so out loud once we cross the "longer than usual" mark.
  //
  // The copy deliberately promises no single minute: the walk budget is
  // DEFAULT_WALK_TIMEOUT_MS (300s) and the worst wall-clock reported from the
  // field is 80-120s, so a minute is a promise this screen cannot keep. `onCancel`
  // is what makes the honest number bearable — the user is never trapped here.
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    setIsSlow(false);
    const timer = setTimeout(() => setIsSlow(true), SLOW_WALK_NOTICE_MS);
    return () => clearTimeout(timer);
  }, []);

  // `loadingPercentage` is null whenever the total is unknown — rendering it
  // unguarded used to print the literal string "NaN %".
  const hasPercentage = loadingPercentage !== null && loadingPercentage !== undefined && loadingPercentage !== "NaN";

  return (
    <>
      <Box className={classes.background} />
      <Box className={classes.wrapper} data-cy="eddmMapLoadingScreen">
        <Typography className={classes.loadingWrapper}>
          <Icon type="LoadingBigIcon" size="xxxl" />
        </Typography>
        {!isCalculatingMultipleSelection && (
          <>
            <Typography className={classes.title}>Loading distribution areas</Typography>
          </>
        )}
        <Typography className={classes.description} data-copilot-readout="eddmMapLoadingStatus">
          {isSlow
            ? "Still working — a dense area at a large radius can take a few minutes."
            : "This process may take a moment."}
        </Typography>
        {hasPercentage && <Typography className={classes.description}>{`${loadingPercentage} %`}</Typography>}
        {onCancel && (
          <Button
            className={classes.cancelButton}
            variant="outlined"
            onClick={onCancel}
            data-cy="eddmMapCancelLoadAreasButton"
          >
            Cancel
          </Button>
        )}
      </Box>
    </>
  );
};

export default LoadingScreen;
